import { render, staticRenderFns } from "./DogeSays.vue?vue&type=template&id=7d78d7bc&"
import script from "./DogeSays.vue?vue&type=script&lang=js&"
export * from "./DogeSays.vue?vue&type=script&lang=js&"
import style0 from "./DogeSays.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports